export function stand(myjson) {
  let conceptos = [];
  let header_rowkey = 0;
  myjson.forEach((x) => {
    x.recaudaciones.forEach((r) => {
      if (r.concepto_pago_nombre == 'Matricula') r.xindex = 0;
      else if (r.concepto_pago_nombre == 'Colegiatura') r.xindex = 1;
      else if (r.concepto_pago_nombre == 'Certificación') r.xindex = 2;
      else if (r.concepto_pago_nombre == 'Cursos') r.xindex = 3;
      else if (r.concepto_pago_nombre == 'Otros Ingresos') r.xindex = 4;

      else if (r.concepto_pago_nombre == 'Mensualidad') r.xindex = 5;
      else if (r.concepto_pago_nombre == 'voucher') r.xindex = 6;
      else r.xindex = 7;

      if (r.concepto_pago_nombre == 'Certificación') {
        r.pagos = r.pagos.filter((p) => {
          let dist = p.tipo != 'total_sin_marketing' && p.tipo != 'marketing';
          return dist;
        });
      } else if (r.concepto_pago_nombre == 'Colegiatura') {
        r.pagos = r.pagos.filter((p) => {
          let dist = p.tipo != 'total_sin_marketing';
          return dist;
        });
      } else if (r.concepto_pago_nombre == 'Otros Ingresos') {
        r.pagos = r.pagos.filter((p) => {
          let dist1 =
            p.tipo != 'total_sin_marketing' && p.tipo != 'marketing' && p.tipo != 'vigente' && p.tipo != 'adelantado';
          let dist = dist1 && p.tipo != 'retrasado' && p.tipo != 'por_recuperar';
          return dist;
        });
      } else if (r.concepto_pago_nombre == 'Matricula') {
        r.pagos = r.pagos.filter((p) => {
          let dist1 =
            p.tipo != 'total_sin_marketing' && p.tipo != 'marketing' && p.tipo != 'vigente' && p.tipo != 'adelantado';
          let dist = dist1 && p.tipo != 'retrasado' && p.tipo != 'por_recuperar';
          return dist;
        });
      } else if (r.concepto_pago_nombre == 'Cursos') {
        r.pagos = r.pagos.filter((p) => {
          let dist1 =
            p.tipo != 'total_sin_marketing' && p.tipo != 'marketing' && p.tipo != 'vigente' && p.tipo != 'adelantado';
          let dist = dist1 && p.tipo != 'retrasado' && p.tipo != 'por_recuperar';
          return dist;
        });
      }

      r.pagos.forEach((p) => {
        if (p.tipo == 'total_sin_marketing') p.xindex = 0;
        else if (p.tipo == 'marketing') p.xindex = 1;
        else if (p.tipo == 'vigente') p.xindex = 2;
        else if (p.tipo == 'adelantado') p.xindex = 3;
        else if (p.tipo == 'retrasado') p.xindex = 4;
        else if (p.tipo == 'por_recuperar') p.xindex = 5;
        else if (p.tipo == 'total') p.xindex = 6;
        else p.xindex = 7;
      });

      r.pagos.sort((a, b) => {
        return a.xindex - b.xindex;
      });

      let existe = conceptos.find((xc) => xc.nombre == r.concepto_pago_nombre);
      if (!existe) {
        let xpagos = JSON.parse(JSON.stringify(r.pagos));
        xpagos.map((pp) => {
          pp.monto = 0;
          pp.rowkey = header_rowkey++;
        });
        conceptos.push({ nombre: r.concepto_pago_nombre, xindex: r.xindex, pagos: xpagos });
      }
    });
  });

  myjson.forEach((x) => {
    conceptos.forEach((c) => {
      let existe = x.recaudaciones.find((xc) => xc.concepto_pago_nombre == c.nombre);
      if (!existe) x.recaudaciones.push(JSON.parse(JSON.stringify(c)));
    });
  });

  conceptos.sort((a, b) => {
    return a.xindex - b.xindex;
  });

  myjson.forEach((x) => {
    x.recaudaciones.sort((a, b) => {
      return a.xindex - b.xindex;
    });
  });

  let totales = [];
  let total = 0;
  let rowkey = 0;
  myjson.forEach((x) => {
    x.xtotal_row = 0;
    x.recaudaciones.forEach((r) => {
      r.pagos.forEach((p) => {
        if (p.tipo == 'total') {
          x.xtotal_row += p.monto;
        }
        p.rowkey = rowkey++;
        if (p.tipo == 'total') total += p.monto;
        let ex = totales.find((zp) => zp.rindex == r.xindex && zp.pindex == p.xindex);
        if (ex) {
          ex.monto += p.monto;
        } else {
          totales.push({ rindex: r.xindex, pindex: p.xindex, monto: p.monto });
        }
      });
    });
  });
  totales.push({ rindex: -1, pindex: -1, monto: total });

  /* window.console.log('*****************************************************');
  window.console.log(conceptos);
  window.console.log(myjson);
  window.console.log(totales);
  window.console.log('*****************************************************'); */

  return { data: myjson, headers: conceptos, totales: totales };
}
